module.exports = __webpack_public_path__ + "img/1445645489.4d85e311.jpg";